// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const inlineHeight = "1.25rem";
export const errorFontSize = "12px";
export const errorMarginTop = "8px";
export const wrap = "RadioButtonList__wrap__oiV9A";
export const inline = "RadioButtonList__inline__OFxbJ";
export const label = "RadioButtonList__label__yVLT5";
export const left = "RadioButtonList__left__zTcVG";
export const error = "RadioButtonList__error__RkBxX font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const buttonList = "RadioButtonList__buttonList__QlN65";
export const buttonListItem = "RadioButtonList__buttonListItem__2IO-G";